<template>
  <div v-loading="loading">
    <apply-header :flag="'1'"></apply-header>
    <div class="main" :style="{ 'min-height': getHeight - 80 + 'px' }">
      <Side :step="'2'" v-if="hasLogin"></Side>
      <section v-if="showResult && hasFinished">
        <div class="resultBox">
          <resiliencyChart :resiliency="resiliency" :resiliencyRate="resiliencyRate" ref="resiliency"></resiliencyChart>
          <el-button class="yellowBtn" style="margin-top: 20px; width: 80px; margin-bottom: 20px" v-if="hasLogin" @click="goBack">Back</el-button>
        </div>
      </section>
      <div :class="{'smallBox':true,'widExpand':!hasLogin }" v-else>
        <div class="viewPDF" style="cursor: none">Resiliency Test</div>
        <el-form ref="form" :model="form" label-width="0px" :rules="rules" :inline-message="false">
          <template v-for="(item, index) in form.items">
            <div :key="`title-${index}`" style="font: 16px bold; paddding-top: 15px">{{ index + 1 }}. {{ item.title }}<span style="color: red">*</span></div>
            <el-form-item :key="item.id" :prop="`items[${index}].result`" :ref="`items[${index}].result`">
              <el-radio-group v-model="item.result" :disabled="isAdmin" :class="{'fullWid':!hasLogin}">
                <el-radio size="medium" label="1" style="width: 14%">Very Inaccurate</el-radio>
                <el-radio size="medium" label="2" style="width: 17%">Moderately Inaccurate</el-radio>
                <el-radio size="medium" label="3" style="width: 24%">Neither Accurate nor Inaccurate</el-radio>
                <el-radio size="medium" label="4" style="width: 15%">Moderately Accurate</el-radio>
                <el-radio size="medium" label="5" style="width: 13%">Very Accurate</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-form>
        <div style="margin-top: 10px">
          <el-button class="yellowBtn" @click="submitPrepare" v-if="isNew">Next</el-button>
          <el-button class="yellowBtn" @click="goNext" v-else>Next</el-button>
          <el-button v-if="hasLogin" class="grayBtn" style="margin-left: 10px" @click="goBack">Back</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyHeader from "../../components/ApplyHeader";
import Side from "../../components/Aside.vue";
import resiliencyChart from "./resiliencyChart";
import { chat2Ascii,hasLogin} from "../../../static/js/util";
export default {
  components: { ApplyHeader, Side, resiliencyChart },
  data() {
    return {
      loading: false,
      isAdmin: false,
      isNew: false,
      showResult: false,
      hasFinished: false,
      resiliencyItems: [],
      resiliency: [0, 0, 0, 0, 0, 0, 0],
      resiliencyRate: [0, 0, 0, 0, 0, 0, 0],
      form: {
        items: [],
      },
      rules: {},
    };
  },
  watch: {
    $route(to, from) {
      console.log(from);
      if (to.path === "/resiliencyBoard") {
        this.getData();
      }
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
    getHeight() {
      return document.documentElement.clientHeight;
    },
    hasLogin
  },
  methods: {
    submitPrepare() {
      this.$refs["form"].clearValidate();
      this.$nextTick(() => {
        this.$refs["form"].validate((valid, object) => {
          // console.log("object", object);
          if (valid) {
            let params = this.form;
            params.date = new Date();
            params.email = this.hasLogin?localStorage.getItem("email"):this.$route.query.email
            console.log(params);
            this.$axios
              .post(this.$URL.resiliencyBoardUrl, params)
              .then((res) => {
                this.loading = false;
                if (res && res.code === 0) {
                  localStorage.setItem("testid", res.data.id);
                  this.$message.success("Submit Success!");
                  this.goNext();
                }
              })
              .catch((err) => {
                this.$message.error({ message: err.msg });
                this.loading = false;
              });
          } else {
            const obj = Object.keys(object)[0];
            // console.log(obj);
            const dom = this.$refs[obj][0];
            // console.log(dom);
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    goBack() {
      this.$router.push({ path: "/applicantHome" });
    },
    goNext() {
      let url = !this.hasLogin?window.location.search:''
      this.$router.push({ path: "/abilityBoard"+url });
    },
    getData() {
      let email;
      if (this.$route.query && this.$route.query.model == "review"&&this.$route.query.verify) {
        email = this.$route.query.email;
         var verify = this.$route.query.verify
          var verifyCode = chat2Ascii(email)
          console.log('转哈维',verifyCode)
          if(verifyCode!=verify){
              this.$router.push('/login')
              return
          }
        this.isAdmin = true;
        this.showResult = true;
      
      } else {
        this.isAdmin = false;
        email = localStorage.getItem("email");
      }
      this.loading = true;
      this.$axios
        .get(this.$URL.resiliencyBoardUrl, { params: { email: email } })
        .then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            if (res.data) {
              console.log(res.data);
              const { isNew, hasFinished, items, result } = res.data;
              if (hasFinished) {
                const { score } = result;
                this.showResult = true;
                this.hasFinished = true;
                this.resiliency[0] = score.task;
                this.resiliency[1] = score.ocb;
                this.resiliency[2] = score.adapt;
                this.resiliency[3] = score.resil;
                this.resiliency[4] = score.cwb;
                this.resiliency[5] = score.ldR_EMERGE;
                this.resiliency[6] = score.ldR_EFFECT;

                this.resiliencyRate[0] = score.tasK_RATE;
                this.resiliencyRate[1] = score.ocB_RATE;
                this.resiliencyRate[2] = score.adapT_RATE;
                this.resiliencyRate[3] = score.resiL_RATE;
                this.resiliencyRate[4] = score.cwB_RATE;
                this.resiliencyRate[5] = score.ldR_EMERGE_RATE;
                this.resiliencyRate[6] = score.ldR_EFFECT_RATE;

                if (this.$refs && this.$refs.resiliency) this.$refs.resiliency.update();
              } else {
                this.isNew = isNew;
                this.isAdmin = !isNew;
                for (let index = 0; index < items.length; index++) {
                  const element = items[index];
                  // console.log(element);
                  this.form.items.push({
                    id: element.id,
                    title: element.title,
                    category: element.category,
                    result: element.result,
                    // result: `${Math.floor(Math.random() * (5 - 1)) + 1}`,
                  });
                  this.rules[`items[${index}].result`] = [{ required: true, message: "Required", trigger: "change" }];
                }
              }
              // console.log(this.form);
              // console.log(this.rules);
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error({ message: err.msg });
        });
    },
  },
};
</script>

<style scoped>
.widExpand{
  width: 82%;
}
.fullWid{
  width:100%
}
.smallBox {
  margin: 20px;
}
.resultBox {
  padding-top: 5px;
}
.viewPDF {
  font-size: 18px;
  left: 12.5%;
}
/deep/ .el-form-item {
  margin-top: 10px;
}
/deep/ .el-textarea__inner {
  width: 70%;
  min-height: 100px !important;
}
@media screen and (max-width: 1200px) {
  .viewPDF {
    font-size: 18px;
    left: 19%;
  }
  /deep/ .el-textarea__inner {
    width: 80%;
    min-height: 100px !important;
  }
}
@media screen and (max-width: 1440px) {
}
</style>